import { useState, useEffect } from "react"
import { useAddNewUserMutation } from "./usersApiSlice"
import { useNavigate, useParams } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowAltCircleRight, faSave } from "@fortawesome/free-solid-svg-icons"
import { ROLES } from "../../config/roles"

const USER_REGEX = /^[A-z0-9]{5,20}$/
const PWD_REGEX = /^[A-z0-9!@#$%]{4,12}$/

const NewUserForm = (props) => {
    const {groupId, type} = useParams()
    const [addNewUser, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useAddNewUserMutation()

    const navigate = useNavigate()

    const [username, setUsername] = useState('')
    const [validUsername, setValidUsername] = useState(false)
    const [password, setPassword] = useState('')
    const [validPassword, setValidPassword] = useState(false)
    const [email, setEmail] = useState('')
    const [name, setName] = useState('')
    const [phone, setPhone] = useState('')
    const [groups, setGroups] = useState(groupId!='0'?[groupId]:[])
    const [roles, setRoles] = useState(["Student"])

    useEffect(() => {
        setValidUsername(USER_REGEX.test(username))
    }, [username])

    useEffect(() => {
        setValidPassword(PWD_REGEX.test(password))
    }, [password])

    useEffect(() => {
        if (isSuccess) {
            setUsername('')
            setPassword('')
            setEmail('')
            setName('')
            setPhone('')
            setGroups([])
            setRoles([])
            navigate(`/${type}/${groupId}/users`)
        }
    }, [isSuccess, navigate])

    const onUsernameChanged = e => setUsername(e.target.value)
    const onPasswordChanged = e => setPassword(e.target.value)

    const onRolesChanged = e => {
        const values = Array.from(
            e.target.selectedOptions, //HTMLCollection 
            (option) => option.value
        )
        setRoles(values)
    }

    const onGroupChanged = e => {
        const values = Array.from(
            e.target.selectedOptions, //HTMLCollection 
            (option) => option.value
        )
        setGroups(values)
    }

    const canSave = [roles.length, groups.length, validUsername, validPassword, name,email].every(Boolean) && !isLoading

    const onSaveUserClicked = async (e) => {
        e.preventDefault()
        if (canSave) {
            await addNewUser({ username, password, name, email, phone, groups, roles })
        }
    }

    const options = Object.values(ROLES).map(role => {
        return (
            <option
                key={role}
                value={role}

            > {role}</option >
        )
    })
    
    const groupsOptions = props.groups.map(group => {
        return (
            <option
                key={group.id}
                value={group.id}
            > {group.name}</option >
        )
    })

  

    const errClass = isError ? "errmsg" : "offscreen"
    const validUserClass = !validUsername ? 'form__input--incomplete' : ''
    const validPwdClass = !validPassword ? 'form__input--incomplete' : ''

    const validRolesClass = !Boolean(roles.length) ? 'form__input--incomplete' : ''
    const validGroupsClass = !Boolean(groups.length) ? 'form__input--incomplete' : ''

    const selectRoles = (
        <>
        <label className="form__label" htmlFor="roles">
        ASSIGNED ROLES:</label>
    <select
        id="roles"
        name="roles"
        className={`form__select ${validRolesClass}`}
        multiple={true}
        size="3"
        value={roles}
        onChange={onRolesChanged}
    >
        {options}
    </select>
    </>
    )
    const content = (
        <>
            <p className={errClass}>{error?.data?.message}</p>

            <form className="form" onSubmit={onSaveUserClicked}>
                <div className="form__title-row">
                    <h2>New User</h2>
                    <div className="form-top-bottons">
                    <button
                            className="icon-button"
                            title="Back"
                            onClick={()=>{navigate(`/${type}/${groupId}/users`)}}
                        >
                            <FontAwesomeIcon icon={faArrowAltCircleRight} />
                        </button>
                        <button
                            className="icon-button"
                            title="Save"
                            disabled={!canSave}
                        >
                            <FontAwesomeIcon icon={faSave} />
                        </button>
                    </div>
                </div>
                <label className="form__label" htmlFor="username">
                    Username: <span className="nowrap">[5-20 letters]</span></label>
                <input
                    className={`form__input ${validUserClass}`}
                    id="username"
                    name="username"
                    type="text"
                    autoComplete="off"
                    value={username}
                    onChange={onUsernameChanged}
                />

                <label className="form__label" htmlFor="password">
                    Password: <span className="nowrap">[4-12 chars incl. !@#$%]</span></label>
                <input
                    className={`form__input ${validPwdClass}`}
                    id="password"
                    name="password"
                    type="password"
                    value={password}
                    onChange={onPasswordChanged}
                />
<label className="form__label" htmlFor="name">
                    Name: </label>
                <input
                    className={`form__input ${!name &&'form__input--incomplete'}`}
                    id="name"
                    name="name"                    
                    type="text"
                    value={name}
                    onChange={(e)=>{setName(e.target.value)}}
                />
<label className="form__label" htmlFor="email">
                    Email: </label>
                <input
                    className={`form__input ${!email &&'form__input--incomplete'}`}
                    id="email"
                    email="email"                    
                    type="email"
                    value={email}
                    onChange={(e)=>{setEmail(e.target.value)}}
                />

<label className="form__label" htmlFor="phone">
                    Phone: </label>
                <input
                    className={`form__input`}
                    id="phone"
                    name="phone"                    
                    type="text"
                    value={phone}
                    onChange={(e)=>{setPhone(e.target.value)}}
                />

                {selectRoles}


                <label className="form__label" htmlFor="roles">
        Groups:</label>
    <select
        id="groups"
        name="groups"
        className={`form__select ${validGroupsClass}`}
        multiple={true}
        size="3"
        value={groups}
        onChange={onGroupChanged}
    >
        {groupsOptions}
    </select>
               

            </form>
        </>
    )

    return content
}
export default NewUserForm